import React from 'react';
import { X, Navigation, Upload, Smartphone, Building2, ExternalLink } from 'lucide-react';

const STEP_GROUPS = [
  {
    icon: Upload,
    title: '1 · Crear el mapa (desde la oficina, una vez)',
    steps: [
      'Entra en google.com/mymaps y pulsa "Crear un mapa nuevo".',
      'Pulsa "Importar" y sube el archivo opportunity-mymaps.kml que acabas de descargar.',
      'My Maps crea automáticamente las capas: OPORTUNIDADES (EN CURSO), BASE, ENGINE y COMPETENCE.',
      'Los colores e iconos ya vienen aplicados: bases azul, engines verde, competencia rojo, y las oportunidades como estrella según su estado. Activa el interruptor de "etiquetas" en cada capa para ver el nombre de cada punto.',
      'Opcional: puedes reagrupar con "Agrupar lugares por" usando las columnas estado, categoria o grupo si prefieres otra organización.',
      'Ponle un nombre al mapa: se guarda en tu cuenta de Google.',
    ],
  },
  {
    icon: Smartphone,
    title: '2 · Usarlo conduciendo (app Google Maps)',
    steps: [
      'Abre Google Maps en el móvil con la MISMA cuenta de Google.',
      'Ve a "Guardados" (barra inferior) → pestaña "Mapas" → selecciona tu mapa.',
      'Verás tus puntos superpuestos con sus colores e iconos por marca.',
      'Toca un punto → "Cómo llegar" para la navegación paso a paso hasta ese local.',
    ],
  },
  {
    icon: Building2,
    title: '3 · Desde la oficina',
    steps: [
      'El mismo mapa se ve y edita en mymaps.google.com (escritorio).',
      'Puedes compartirlo por enlace con tu equipo e imprimirlo.',
    ],
  },
];

const MyMapsHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(5, 7, 10, 0.85)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2500,
        backdropFilter: 'blur(5px)',
        padding: '20px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#1A1A1A',
          border: '1px solid #0B3D91',
          padding: '30px',
          width: '560px',
          maxWidth: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          borderRadius: '4px',
          boxShadow: '0 0 30px rgba(0, 206, 201, 0.2)',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{ position: 'absolute', right: '15px', top: '15px', background: 'none', border: 'none', color: '#888', cursor: 'pointer' }}
        >
          <X size={20} />
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
          <Navigation color="#00CEC9" />
          <h2 style={{ color: '#F0F0F0', letterSpacing: '2px', fontSize: '1.1rem', margin: 0, textTransform: 'uppercase' }}>
            Ver tus mapas en Google My Maps
          </h2>
        </div>
        <p style={{ color: '#888', fontSize: '0.75rem', margin: '0 0 18px', lineHeight: 1.5 }}>
          Exporta desde EXCHANGE → "Exportar para Google My Maps" y sigue estos pasos para tener tu
          mapa listo para consultar al volante.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '22px', fontSize: '0.72rem' }}>
          {[
            { c: '#E53935', t: 'Oportunidades (♥ rojo)' },
            { c: '#A52714', t: 'Bases · BK (🏠 rojo)' },
            { c: '#FF6B00', t: 'Bases · Popeyes (🏠 naranja)' },
            { c: '#2E7D32', t: 'Engines (círculo verde)' },
            { c: '#C62828', t: 'Competencia (círculo rojo)' },
          ].map((k) => (
            <span key={k.t} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: '#CCC' }}>
              <span style={{ width: '11px', height: '11px', borderRadius: '50%', backgroundColor: k.c, flexShrink: 0 }} />
              {k.t}
            </span>
          ))}
        </div>

        {STEP_GROUPS.map((group, gi) => {
          const Icon = group.icon;
          return (
            <div key={gi} style={{ marginBottom: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#E27B58', fontSize: '0.8rem', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                <Icon size={15} />
                <span>{group.title}</span>
              </div>
              <ol style={{ margin: 0, paddingLeft: '18px', color: '#CCC', fontSize: '0.8rem', lineHeight: 1.6 }}>
                {group.steps.map((s, si) => (
                  <li key={si} style={{ marginBottom: '5px' }}>{s}</li>
                ))}
              </ol>
            </div>
          );
        })}

        <div style={{ borderTop: '1px solid #2A2A2A', paddingTop: '14px', marginTop: '6px' }}>
          <p style={{ color: '#666', fontSize: '0.7rem', margin: '0 0 14px', lineHeight: 1.5 }}>
            Límites de My Maps: 2.000 puntos por capa, 10 capas y 10.000 puntos por mapa. Si tienes
            muchos locales, oculta marcas en el mapa antes de exportar (solo se exporta lo visible).
          </p>
          <a
            href="https://www.google.com/mymaps"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '9px 16px',
              backgroundColor: 'rgba(0, 206, 201, 0.1)',
              border: '1px solid #00CEC9',
              borderRadius: '4px',
              color: '#00CEC9',
              textDecoration: 'none',
              fontSize: '0.8rem',
              letterSpacing: '1px',
            }}
          >
            <ExternalLink size={15} /> ABRIR GOOGLE MY MAPS
          </a>
        </div>
      </div>
    </div>
  );
};

export default MyMapsHelpModal;
